import { Button } from '@material-tailwind/react'
import React from 'react'

const UserForm = ({
  name,
  setName,
  email,
  setEmail,
  password,
  setPassword,
  companyName,
  setCompanyName,
  gstNo,
  setGstNo,
  agreement,
  gstDocument,
  insuranceType,
  setInsuranceType,
  contact,
  setContact,
  companyAddress,
  setCompanyAddress,
  handleCreateUser,
  addGSTInformation,
  addAgreementInformation,
  rateChart,
  setRateChart,
  handleConvert
}) => {
  const primaryFields = [
    { key: 'name', label: 'Client Name', value: name, onChange: setName, placeholder: 'Full client name', type: 'text' },
    { key: 'companyName', label: 'Company Name', value: companyName, onChange: setCompanyName, placeholder: 'Registered company name', type: 'text' },
    { key: 'email', label: 'Email', value: email, onChange: setEmail, placeholder: 'Email address', type: 'email' },
    { key: 'password', label: 'Password', value: password, onChange: setPassword, placeholder: 'Create password', type: 'password' },
    { key: 'contact', label: 'Contact No', value: contact, onChange: setContact, placeholder: 'Phone number', type: 'text' },
    { key: 'gstNo', label: 'GST No', value: gstNo, onChange: setGstNo, placeholder: 'GST number', type: 'text' },
  ]

  return (
    <div className='mx-4 my-6 md:mx-6'>
      <div className='rounded-[28px] border border-slate-200 bg-white px-6 py-6 shadow-[0_18px_42px_rgba(15,23,42,0.07)]'>
        <div className='grid gap-6 xl:grid-cols-[minmax(0,1.2fr)_minmax(0,0.8fr)]'>
          <div className='rounded-[24px] border border-slate-200 bg-[linear-gradient(180deg,_#ffffff,_#f8fafc)] p-5'>
            <div className='mb-5 border-b border-slate-100 pb-4'>
              <p className='text-sm font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400'>Account details</p>
              <p className='mt-1 text-sm text-slate-500'>Fill in the identity, login, and billing information for the client account.</p>
            </div>

            <div className='grid gap-5 md:grid-cols-2'>
              {primaryFields.map((field) => (
                <label key={field.key} className='block'>
                  <span className='mb-2 block text-[11px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-500'>{field.label}</span>
                  <input
                    value={field.value}
                    onChange={(e) => field.onChange(e.target.value)}
                    placeholder={field.placeholder}
                    type={field.type}
                    className='h-14 w-full rounded-[18px] border border-slate-200 bg-white px-4 text-base font-[GilroyMedium] text-slate-900 shadow-[0_8px_20px_rgba(15,23,42,0.04)] outline-none transition placeholder:text-slate-300 focus:border-[#f97316] focus:ring-4 focus:ring-[#f97316]/10'
                  />
                </label>
              ))}

              <label className='block md:col-span-2'>
                <span className='mb-2 block text-[11px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-500'>Company Address</span>
                <textarea
                  value={companyAddress}
                  onChange={(e) => setCompanyAddress(e.target.value)}
                  placeholder='Registered company address'
                  rows={4}
                  className='w-full rounded-[18px] border border-slate-200 bg-white px-4 py-4 text-base font-[GilroyMedium] text-slate-900 shadow-[0_8px_20px_rgba(15,23,42,0.04)] outline-none transition placeholder:text-slate-300 focus:border-[#f97316] focus:ring-4 focus:ring-[#f97316]/10'
                />
              </label>

              <label className='block md:col-span-2'>
                <span className='mb-2 block text-[11px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-500'>Insurance Type</span>
                <select
                  value={insuranceType}
                  onChange={(e) => setInsuranceType(e.target.value)}
                  className='h-14 w-full rounded-[18px] border border-slate-200 bg-white px-4 text-base font-[GilroyMedium] text-slate-900 shadow-[0_8px_20px_rgba(15,23,42,0.04)] outline-none transition focus:border-[#f97316] focus:ring-4 focus:ring-[#f97316]/10'
                >
                  <option value=''>Select insurance type</option>
                  <option value='owner risk'>Owners Risk</option>
                  <option value='carrier risk'>Carrier Risk</option>
                </select>
              </label>
            </div>
          </div>

          <div className='space-y-5'>
            <div className='rounded-[24px] border border-slate-200 bg-slate-50/80 p-5'>
              <p className='mb-4 text-sm font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400'>Documents</p>
              <div className='space-y-4'>
                <form onSubmit={addGSTInformation} className='rounded-[20px] border border-slate-200 bg-white p-4 shadow-[0_8px_20px_rgba(15,23,42,0.04)]'>
                  <p className='text-sm font-[GilroyBold] text-slate-900'>GST Copy</p>
                  <input type='file' className='mt-3 block w-full text-sm text-slate-500 file:mr-4 file:rounded-full file:border-0 file:bg-slate-100 file:px-4 file:py-2 file:text-xs file:font-[GilroyBold] file:text-slate-700' />
                  <Button type='submit' className='mt-4 rounded-full bg-[#f97316] px-4 py-2 text-xs font-[GilroyBold] text-white shadow-none hover:bg-[#ea580c]'>Upload GST</Button>
                  <p className='mt-3 break-all text-xs text-slate-400'>{gstDocument || 'No GST file uploaded yet'}</p>
                </form>

                <form onSubmit={addAgreementInformation} className='rounded-[20px] border border-slate-200 bg-white p-4 shadow-[0_8px_20px_rgba(15,23,42,0.04)]'>
                  <p className='text-sm font-[GilroyBold] text-slate-900'>Agreement</p>
                  <input type='file' className='mt-3 block w-full text-sm text-slate-500 file:mr-4 file:rounded-full file:border-0 file:bg-slate-100 file:px-4 file:py-2 file:text-xs file:font-[GilroyBold] file:text-slate-700' />
                  <Button type='submit' className='mt-4 rounded-full bg-[#f97316] px-4 py-2 text-xs font-[GilroyBold] text-white shadow-none hover:bg-[#ea580c]'>Upload Agreement</Button>
                  <p className='mt-3 break-all text-xs text-slate-400'>{agreement || 'No agreement uploaded yet'}</p>
                </form>
              </div>
            </div>

            <div className='rounded-[24px] border border-slate-200 bg-slate-50/80 p-5'>
              <p className='mb-4 text-sm font-[GilroyBold] uppercase tracking-[0.14em] text-slate-400'>Rate card</p>
              <div className='rounded-[20px] border border-slate-200 bg-white p-4 shadow-[0_8px_20px_rgba(15,23,42,0.04)]'>
                <input type="file" accept=".xls,.xlsx" onChange={e => setRateChart(e.target.files[0])} className='block w-full text-sm text-slate-500 file:mr-4 file:rounded-full file:border-0 file:bg-slate-100 file:px-4 file:py-2 file:text-xs file:font-[GilroyBold] file:text-slate-700' />
                <Button onClick={handleConvert} className='mt-4 rounded-full bg-slate-900 px-4 py-2 text-xs font-[GilroyBold] text-white shadow-none hover:bg-slate-800'>Upload Rate Chart</Button>
                <p className='mt-3 text-xs text-slate-400'>{rateChart?.name || 'No rate chart selected'}</p>
              </div>
            </div>
          </div>
        </div>

        <div className='mt-6 flex justify-end'>
          <Button onClick={handleCreateUser} className='rounded-full bg-[#f97316] px-8 py-3 text-sm font-[GilroyBold] text-white shadow-[0_14px_30px_rgba(249,115,22,0.2)] hover:bg-[#ea580c]'>
            Create Client
          </Button>
        </div>
      </div>
    </div>
  )
}

export default UserForm
